import type { $Fetch } from 'ofetch';
import type { LossReasonGateway } from '@/application/port/out/LossReasonGateway';
import type { LossReason, UpsertLossReasonCommand } from '@/domain/model/LossReason';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const ROOT = '/api/v1/commerce/loss-reasons';

/** HTTP gateway de Motivos de Perda. Authority BE: leitura via lead; manage `commerce:lossreason:manage`. */
export class HttpLossReasonGateway implements LossReasonGateway {
  constructor(private readonly client: $Fetch) {}

  async list(): Promise<LossReason[]> {
    const res = await this.client<ApiResponse<LossReason[]>>(ROOT, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async create(cmd: UpsertLossReasonCommand): Promise<LossReason> {
    const res = await this.client<ApiResponse<LossReason>>(ROOT, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, cmd: UpsertLossReasonCommand): Promise<LossReason> {
    const res = await this.client<ApiResponse<LossReason>>(
      `${ROOT}/${encodeURIComponent(id)}`, { method: 'PUT', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async remove(id: string): Promise<void> {
    await this.client<void>(`${ROOT}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }
}
